export default __webpack_public_path__ + "static/11_21-e240bb8bd097bb518cedf848430c710a.png";